import { render, staticRenderFns } from "./VetVehicleType.vue?vue&type=template&id=176d2668&scoped=true"
import script from "./VetVehicleType.vue?vue&type=script&lang=js"
export * from "./VetVehicleType.vue?vue&type=script&lang=js"
import style0 from "./VetVehicleType.vue?vue&type=style&index=0&id=176d2668&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "176d2668",
  null
  
)

export default component.exports